module.exports = __webpack_public_path__ + "img/slider-arrow-right.5e11d84.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/slider-arrow-right.svg
// module id = 9HDz
// module chunks = 0 1 2 5 6